import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';

export type InvitationResentPayload = UserPayload;

export type InvitationResentAction = {
	type: 'INVITATION_RESENT';
	payload: InvitationResentPayload;
	accountId: number;
};

export default (payload: InvitationResentPayload, accountId: number): InvitationResentAction => ({
	type: 'INVITATION_RESENT',
	payload,
	accountId,
});
